import React from 'react';

export default function ShippingAndReturnsAccordionContent({
  shippingContent = null,
  tmntContent = null,
  siteRegion,
}) {
  if (!shippingContent) return null;

  function renderShippingReturnMarkup() {
    const { hasSimpleReturns } = shippingContent;
    const tmntSimpleReturnsContent = tmntContent?.simpleReturnsContent?.value;

    return hasSimpleReturns && tmntSimpleReturnsContent ? (
      <>
        <hr />
        <div dangerouslySetInnerHTML={{ __html: `<div>${tmntSimpleReturnsContent}</div>` }} />
      </>
    ) : null;
  }

  function renderShippingAndHandlingBody() {
    const tmtntLeftTab = tmntContent[`shippingAndHandling${siteRegion}LeftTab`] && tmntContent[`shippingAndHandling${siteRegion}LeftTab`].value;
    const tmntRightTab = tmntContent[`shippingAndHandling${siteRegion}RightTab`] && tmntContent[`shippingAndHandling${siteRegion}RightTab`].value;
    return (
      <div data-content={siteRegion} className={`shippingAndHandling-body shippingAndHandling-${siteRegion}`}>
        <div className="a-row">
          {tmtntLeftTab && (
          <div className="shippingAndHandling__rate-table-tab a-xs-8" data-testid={`shippingAndHandling-${siteRegion}-leftTab`}>
            <div dangerouslySetInnerHTML={{ __html: `<div>${tmtntLeftTab}</div>` }} />
          </div>
          )}
          {tmntRightTab && (
          <div className="shippingAndHandling__additional-info-tab a-xs-8" data-testid={`shippingAndHandling-${siteRegion}-rightTab`}>
            <div dangerouslySetInnerHTML={{ __html: `<div>${tmntRightTab}</div>` }} />
          </div>
          )}
        </div>
      </div>
    );
  }

  function renderShippingAndHandlingFooter() {
    const tmntFooter = tmntContent[`shippingAndHandling${siteRegion}Footer`] && tmntContent[`shippingAndHandling${siteRegion}Footer`].value;
    if (!tmntFooter) return null;

    return (
      <div data-content={siteRegion} className={`shippingAndHandling-footer shippingAndHandling-${siteRegion} module-section__footer`} data-testid={`shippingAndHandling-${siteRegion}-footer`}>
        <div className="module-section__footer-content">
          <div dangerouslySetInnerHTML={{ __html: `<div>${tmntFooter}</div>` }} />
        </div>
      </div>
    );
  }

  return (
    <div className="shipping-returns-accordion-container" data-testid="shipping-returns-content">
      <div id="shipping-and-handling" className="shipping-handling-help-page scope-1892" data-content={siteRegion}>
        {renderShippingAndHandlingBody()}
        {renderShippingAndHandlingFooter()}
      </div>
      {renderShippingReturnMarkup()}
    </div>
  );
}
